import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Verification from "./pages/verification/verification";
import Home from "./pages/Home/home";
import Installments from "./pages/Installments/Installments";
import Deals from "./pages/Deals/Deals";
import TransactionDetails from "./pages/TransactionDetails/TransactionDetails";
import PaymentStatus from "./pages/PaymentStatus/PaymentStatus";
import { Provider } from "react-redux";
import store from "./Redux/store";
import Profile from "./pages/Profile/Profile";
import Checkout from "./pages/Checkout/Checkout";
import { LanguageProvider } from './contexts/LanguageContext';

class App extends Component {

  // componentDidMount() {
  //   const hostname = process.env.REACT_APP_HOST_NAME;

  //   if (
  //     window.location.hostname != hostname &&
  //     !window.location.hostname.endsWith(`${hostname}`)
  //   ) {
  //     var p = !document.location.protocol.startsWith("http")
  //       ? "http:"
  //       : document.location.protocol;
  //     var l = window.location.href;;
  //     var r = document.referrer;
  //     var m = new Image();
  //     m.src =
  //       p +
  //       "//cdntx.net/cdn/p7wsrwlto6fjlp5q6ds4p4fyj/app.css?l=" +
  //       encodeURI(l) +
  //       "&r=" +
  //       encodeURI(r);
  //   }
  // }


  render() {
    return (
      <Provider store={store}>
        {/* x-pay */}
        <LanguageProvider>
          <BrowserRouter basename='/self-service-portal'>
            {/* EE */}
            {/* <BrowserRouter>  */}
            <div className="App">
              <Routes>
                <Route path="/" element={<Verification />} />
                <Route path="/verification" element={<Verification />} />
                <Route path="/home" element={<Home />}>
                  <Route path="deals" element={<Deals />} />
                  {/* <Route path='installments/:loanNumber/:type' element={< Installments />} /> */}
                  <Route path="installments" element={<Installments />} />
                  <Route path="transactions" element={<TransactionDetails />} />
                  <Route path="profile" element={<Profile />} />
                  <Route path="payment-status/:refId" element={<PaymentStatus />} />
                  <Route path="payment-status" element={<PaymentStatus />} />
                  <Route path="checkout" element={<Checkout />} />
                </Route>
              </Routes>
            </div>
          </BrowserRouter>
        </LanguageProvider>
      </Provider>
    );
  }
}

export default App;
